<template>
  <div class="full-width full-height" ref="photoContainer">
    <PhotoHorizontalSlider
      ref="horizontalSlider"
      :behavior="behavior"
      v-if="imageContainerType === 'horizontal'"
      :src="imageDate.src"
      :imgStyle="imageDate.imgStyle"
      :section="image.section"
    />
    <PhotoVerticalSlider
      ref="verticalSlider"
      :behavior="behavior"
      v-if="imageContainerType === 'vertical'"
      :src="imageDate.src"
      :imgStyle="imageDate.imgStyle"
      :section="image.section"
    />
  </div>
</template>
<script>
import getImgUrl from "../../mixins/get-img-url";
import PhotoHorizontalSlider from "./PhotoHorizontalSlider.vue";
import PhotoVerticalSlider from "./PhotoVerticalSlider.vue";
export default {
  name: "PhotoSlider",
  components: {
    PhotoHorizontalSlider,
    PhotoVerticalSlider,
  },
  props: {
    behavior: {
      type: String,
      default: "agent",
    },
    image: {
      type: Object,
      required: true,
    },
    cid: {
      type: String,
      default: "cenora",
    },
  },
  mixins: [getImgUrl],
  data() {
    return {
      imageContainerType: null,
      srcOnError: "",
    };
  },
  computed: {
    imageDate: {
      get() {
        if (this.srcOnError) {
          return {
            ...this.image,
            src: this.srcOnError,
          };
        }

        return this.image;
      },
    },
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      const preloadImg = new Image();
      preloadImg.onload = () => {
        if (this.image.type === "image") {
          if (!this.$refs.photoContainer) {
            return;
          }
          const rect = this.$refs.photoContainer.getBoundingClientRect();
          const finalHeight =
            (rect.width * preloadImg.height) / preloadImg.width;
          if (
            preloadImg.height > preloadImg.width &&
            finalHeight >= rect.height
          ) {
            this.imageContainerType = "vertical";
          } else {
            this.imageContainerType = "horizontal";
          }
        } else {
          this.imageContainerType = "video-image";
        }
      };

      preloadImg.onerror = (ev) => {
        const src = this.onError(ev, this.cid, this.image.section, {
          returnValue: true,
        });

        if (preloadImg.src === src) {
          return;
        }

        preloadImg.src = src;
        this.srcOnError = src;
      };

      preloadImg.src = this.image.src;
    },
  },
};
</script>
